<template>
    <div class="feature-tour-slides">
        <div class="slide-indicators-container">
            <div
                v-for="n in slides.length"
                :key="n - 1"
                :class="['slide-indicator', { active: activeSlide === n - 1 }]"
                @click="animateSlide(n - 1)"
            />
        </div>

        <transition
            v-for="(slide, i) in slides"
            :key="i"
            name="fade-in"
        >
            <feature-tour-slide
                v-if="shouldShowSlide(i)"
                :final-slide="isFinalSlide"
                :title="slide.title"
                :description="slide.description"
                :image="slide.image"
                :guide-location="slide.guideLocation"
                :guide-position="slide.guidePosition"
                :guide-text="slide.guideText"
                @next="next"
                @back="back"
                @done="done"
            />
        </transition>
    </div>
</template>

<script>
import FeatureTourSlide from './FeatureTourSlide';

export default {
    components: {
        FeatureTourSlide,
    },

    props: {
        skipMounted: Boolean,
        slides: {
            type: Array,
            default: () => [],
        },
        slideDuration: {
            type: Number,
            default: 500,
        },
    },

    data() {
        return {
            animating: false,
            activeSlide: -1,
        };
    },

    async mounted() {
        if (!this.skipMounted) {
            await this.wait();

            this.next();
        }
    },

    computed: {
        isFinalSlide() {
            return this.activeSlide === this.slides.length - 1;
        },
    },

    methods: {
        async animateSlide(newStep) {
            this.animating = true;
            this.activeSlide = newStep;

            await this.wait();

            this.animating = false;
        },

        back() {
            this.animateSlide(this.activeSlide - 1);
        },

        async done() {
            this.animating = true;

            await this.wait();

            this.$emit('complete');
        },

        next() {
            if (this.activeSlide === this.slides.length - 1) {
                this.done();
            } else {
                this.animateSlide(this.activeSlide + 1);
            }
        },

        shouldShowSlide(slide) {
            return this.activeSlide === slide && !this.animating;
        },

        wait() {
            return new Promise((resolve) => setTimeout(resolve, this.slideDuration));
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .feature-tour-slides {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .slide-indicators-container {
        display: flex;
        align-items: center;
        margin: $spacing-400;
    }

    .slide-indicator {
        @include transition(background-color);
        @include circle(8px);

        background-color: $color-gray-200;
        margin: 0 $spacing-100;
        cursor: pointer;

        &:hover {
            background-color: $color-gray-600;
        }

        &.active {
            background-color: $color-gray-900;
        }
    }

    .fade-in-enter-active {
        transition: all 0.5s ease;
    }

    .fade-in-leave-active {
        transition: all 0.5s cubic-bezier(1.0, 0.5, 0.5, 1.0);
    }

    .fade-in-enter,
    .fade-in-leave-to {
        opacity: 0;
    }
</style>
